import cn from 'classnames';

import type { Flag } from '../../../types';
import { useFlag } from '../use-flag';
import css from './select.module.scss';

interface Props {
    flag: Flag;
}
export function Select({ flag }: Props) {
    const { value, onChange, disabled } = useFlag(flag);

    return (
        <select id={flag.id} className={css.select} value={value as string} onChange={e => onChange(e.target.value)}>
            <button>
                <selectedcontent />
                <span className={css.arrow}>⌃</span>
            </button>
            {flag.options.map(variant => (
                <option
                    key={variant}
                    value={variant}
                    className={cn(css.option, {
                        [css.selected]: variant === value,
                        [css.hide]: disabled,
                    })}
                >
                    {variant}
                </option>
            ))}

            {disabled && (
                <option className={css.empty} disabled>
                    <span className={css.icon}>⊗</span>
                    <span className={css.text}>The flag’s rules block the other options</span>
                </option>
            )}
        </select>
    );
}
